var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["header/logo.j2"] = require( "header/logo.j2" );
dependencies["header/brand-navigation.j2"] = require( "header/brand-navigation.j2" );
dependencies["header/menu-toggle.j2"] = require( "header/menu-toggle.j2" );
dependencies["header/search.j2"] = require( "header/search.j2" );
dependencies["header/utility.j2"] = require( "header/utility.j2" );
dependencies["header/cart.j2"] = require( "header/cart.j2" );
dependencies["header/cart-confirm.j2"] = require( "header/cart-confirm.j2" );
dependencies["header/main-navigation.j2"] = require( "header/main-navigation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/global-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<header class=\"c-global-header-wrap js-global-header-wrap dom-header ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fixedHeaderClass"), env.opts.autoescape);
output += "\" data-qa-header-wrap>\n\n    <div class=\"c-global-header\">\n\n        <div class=\"dom-site-header c-site-header";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteDown")?" c-site-header--site-down":""), env.opts.autoescape);
output += "\">\n\n            <div class=\"o-row c-site-header__inner\">\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteDown")) {
output += "\n\n                    <div class=\"o-column o-extra-small--12 u-centered-content\">\n\n                        ";
env.getTemplate("header/logo.j2", false, "core/templates/global-header.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n                    </div>\n\n                ";
})});
}
else {
output += "\n\n\n                    <div class=\"c-site-header__flex-brand-navigation u-extra-small--hide u-large--show\">\n\n                        ";
env.getTemplate("header/brand-navigation.j2", false, "core/templates/global-header.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n                    </div>\n\n                    <div class=\"o-column o-extra-small--2 u-large--hide\">\n\n                        ";
env.getTemplate("header/menu-toggle.j2", false, "core/templates/global-header.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n                    </div>\n\n                    <div class=\"o-column o-extra-small--7 o-medium--8 o-large--4 u-centered-content c-site-header__flex-logo\">\n\n                        ";
env.getTemplate("header/logo.j2", false, "core/templates/global-header.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n                    </div>\n\n                    ";
output += "\n                    <div class=\"o-column o-extra-small--3 o-medium--2 c-site-header__flex-utility\">\n\n                        <div class=\"c-utility__large\" data-qa-desktop-header>";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteDown")) {
output += "<div class=\"c-site-search-outer\">\n                                \n                                    ";
env.getTemplate("header/search.j2", false, "core/templates/global-header.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n                                \n                                </div>";
})});
}
output += "<div class=\"u-extra-small--hide u-large--show\" data-qa-mobile-header>\n\n                                ";
env.getTemplate("header/utility.j2", false, "core/templates/global-header.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n                            </div>\n\n                            ";
env.getTemplate("header/cart.j2", false, "core/templates/global-header.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n                        </div>\n\n                    </div>\n\n                ";
})})})})})})})})})});
}
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteDown") && (!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish"))) {
env.getTemplate("header/cart-confirm.j2", false, "core/templates/global-header.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
})});
}
output += "</div><!-- //c-site-header__inner -->\n\n        </div><!-- //c-site-header -->\n\n        ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteDown")) {
output += "\n\n            <div class=\"c-off-menu js-off-menu dom-off-menu\">\n\n                ";
env.getTemplate("header/main-navigation.j2", false, "core/templates/global-header.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n\n                <div class=\"u-large--hide\">\n\n                    ";
env.getTemplate("header/utility.j2", false, "core/templates/global-header.j2", null, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
t_37.render(context.getVariables(), frame, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
output += t_38
output += "\n\n                </div>\n\n            </div>\n\n        ";
})})})});
}
output += "\n\n    </div>\n\n</header>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/global-header.j2"] , dependencies)